import React, { useEffect, useState, useReducer } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callGACCApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
import { getStrLang } from '../../Translate';
import { IoChevronBackOutline } from 'react-icons/io5';

const GACC = (props) => {
    const { translate, lang } = useLanguage();
    const [loadingGACCInfo, setLoadingGACCInfo] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [infoGACC, setInfoGACC] = useState(
        sessionStorage.getItem("gacc_info")
            ? JSON.parse(sessionStorage.getItem("gacc_info"))
            : {}
    );
    const [waitingPayment, setWaitingPayment] = useState(
        sessionStorage.getItem("gacc_waiting_payment")
            ? JSON.parse(sessionStorage.getItem("gacc_waiting_payment"))
            : false
    );
    const [isError, setIsError] = useState(false);
    const [erorMsg, setErrorMsg] = useState("");

    // Address fields for GACC
    const [showAddressForm, setShowAddressForm] = useState(true);
    const [addressData, setAddressData] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {
            full_address: "",
            city: "",
            state: "",
            zip: ""
        }
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        translate();
    }, [translate]);

    // Fetch deposit data to prefill address
    useEffect(() => {
        getDeposit(sessionStorage.getItem("order_no"))
            .then(res => {
                if (res && res.full_address) {
                    setAddressData({
                        full_address: res.full_address || ""
                    });
                }
            })
            .catch(err => {
                console.log("Error fetching deposit data:", err);
            })
    }, []);

    const callGacc = () => {
        setLoadingGACCInfo(true);
        setErrorMsg('')
        callGACCApi(sessionStorage.getItem("order_no"), {
            full_address: addressData.full_address,
            city: addressData.city,
            state: addressData.state,
            zip: addressData.zip
        })
            .then(res => {
                if (res.status === "REDIRECT") {
                    const newInfo = { ...infoGACC, [props.payment_type]: res };
                    setInfoGACC(newInfo);
                    sessionStorage.setItem("gacc_info", JSON.stringify(newInfo));
                    setWaitingPayment(true);
                    setLoadingGACCInfo(false);
                } else {
                    setErrorMsg(res.message || "Please, talk with the Administrator.");
                    setLoadingGACCInfo(false);
                    setIsError(true);
                }
            })
            .catch(err => {
                console.log(err.toString());
                setErrorMsg(
                    err.response?.data?.error
                        ? err.response?.data?.error
                        : "Internal server error"
                );
                setIsError(true);
            })
            .finally(() => {
                setLoadingGACCInfo(false);
                translate();
            });
    };

    // Check for payment status every 30 seconds if waitingPayment is true.
    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("gacc_waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    });
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("gacc_waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [waitingPayment]);

    // Don't auto-call - wait for address form submission
    // useEffect(() => {
    //     if (!infoGACC[props.payment_type]) {
    //         callGacc();
    //     }
    // }, []);

    const [loading, setLoading] = useState(true);
    const handleLoad = () => {
        setLoading(false);
    };

    const handleAddressInput = evt => {
        const name = evt.target.name;
        setAddressData({ [name]: evt.target.value });
    };

    const saveAddressData = (e) => {
        e.preventDefault();
        setShowAddressForm(false);
        // Call GACC API after address is saved
        callGacc();
    };

    const backToAddressForm = () => {
        setShowAddressForm(true);
    };

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'redirected') {
                const redirectedUrl = event.data.url;
                window.location.href = redirectedUrl;
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <>
            {loadingGACCInfo && (
                <div className="group-pix-content">
                    <div className="pix-container">
                        <div className="grup-crypto-opt">
                            <div className="msg-pix">
                                <img src={Loading} alt="loading" width="30px" height="30px" />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className=''>
                {/* Address form - shown first */}
                {showAddressForm && !infoGACC[props.payment_type] && !loadingGACCInfo && (
                    <div className='row'>
                        <div className='col-md-12 d-flex justify-content-center'>
                            <form style={{ minWidth: window.innerWidth <= 768 ? "90%" : "70%" }} onSubmit={saveAddressData}>
                                <div className='form-group'>
                                    <label htmlFor="full_address">{getStrLang(lang.nameLang, "address") || "Full Address"}</label>
                                    <input 
                                        type="text" 
                                        className='form-control' 
                                        id="full_address" 
                                        name="full_address"
                                        placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "address") || "address"}`} 
                                        value={addressData.full_address} 
                                        onChange={handleAddressInput} 
                                        required 
                                    />
                                </div>

                                <div className='form-group'>
                                    <label htmlFor="city">{getStrLang(lang.nameLang, "city") || "City"}</label>
                                    <input 
                                        type="text" 
                                        className='form-control' 
                                        id="city" 
                                        name="city"
                                        placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "city") || "city"}`} 
                                        value={addressData.city} 
                                        onChange={handleAddressInput} 
                                        required 
                                    />
                                </div>

                                <div className='form-group'>
                                    <label htmlFor="state">{getStrLang(lang.nameLang, "state") || "State"}</label>
                                    <input 
                                        type="text" 
                                        className='form-control' 
                                        id="state" 
                                        name="state"
                                        placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "state") || "state"}`} 
                                        value={addressData.state} 
                                        onChange={handleAddressInput} 
                                        required 
                                    />
                                </div>

                                <div className='form-group'>
                                    <label htmlFor="zip">{getStrLang(lang.nameLang, "zip_code") || "ZIP Code"}</label>
                                    <input 
                                        type="text" 
                                        className='form-control' 
                                        id="zip" 
                                        name="zip"
                                        placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "zip_code") || "ZIP code"}`} 
                                        value={addressData.zip} 
                                        onChange={handleAddressInput} 
                                        required 
                                    />
                                </div>

                                <button className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "continue") || "Continue"}</button>
                            </form>
                        </div>
                    </div>
                )}

                {/* Back button when iframe is shown */}
                {infoGACC[props.payment_type] !== undefined && (
                    <div className="column-pix-sides" style={{ marginBottom: '10px' }}>
                        <button className="btn-split-pix" onClick={backToAddressForm}>
                            <IoChevronBackOutline size={25} /> {getStrLang(lang.nameLang, "btn_voltar") || "Back"}
                        </button>
                    </div>
                )}

                {/* When the payment URL is available, display the iframe */}
                {infoGACC[props.payment_type] !== undefined && (
                    <div style={{ width: '100%' }}>
                        <iframe
                            id="gacc_frame"
                            src={`${infoGACC[props.payment_type]['redirect_url']}`}
                            title={`${props.payment_type}`}
                            width="100%"
                            height="800px"
                            onLoad={handleLoad}
                            style={{ display: loading ? 'none' : 'block' }}
                        />
                    </div>
                )}

                {isError && (
                    <div
                        style={{
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <h4>{erorMsg}</h4>
                    </div>
                )}
            </div>
        </>
    );
};

export default GACC;
